import React from "react";
import de from "../../assets/texts/de.json";
import sr from "../../assets/texts/sr.json";
import { useLanguage } from "../../i18n/LanguageContext";
import BreakLine from "../../assets/images/Icons/decorativeLine.png";
import checkedIcon from "../../assets/images/Icons/checkedIcon.png";
import AOS from "aos";
import "aos/dist/aos.css";

export default function AboutSection() {
  AOS.init({ duration: 2000 });
  const { language } = useLanguage();
  const data = language === "sr" ? sr : de;
  return (
    <div className="about-section">
      <div className="about-container">
        <div className="section-title" data-aos="fade-down">
          <h2>{data.aboutUs.title}</h2>
        </div>
        <div className="section-content" data-aos="fade-left">
          <div className="content-text">
            <p className="text">{data.aboutUs.content}</p>
          </div>
          <img src={BreakLine} alt="" />
          <div className="content-list">
            {data.aboutUs.skills.map((e, index) => (
              <div key={index} className="row">
                <img src={checkedIcon} alt="icon"></img>
                <p className="skill">{e}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
